import { ReactNode } from "react";
import { ListItem, ListItemText } from "@mui/material";
import { useCustomerKey } from "utils/customHooks/useCustomerKey";
import { useIsStorybook } from "utils/customHooks/storyHooks";
import { Link } from "react-router-dom";

type ReportListItemProps = {
  reportTitle: string;
  portalReportPath?: string;
  reportSubtitle?: string;
  externalToPortalLink?: string;
  icon?: ReactNode;
};

const ReportListItem = ({
  reportTitle,
  reportSubtitle = "",
  portalReportPath,
  externalToPortalLink,
  icon = null,
}: ReportListItemProps) => {
  const ckey = useCustomerKey();
  // Opens reports in Flight
  return (
    <Link
      to={
        externalToPortalLink
          ? externalToPortalLink
          : `/${ckey}/reports/${portalReportPath}`
      }
      rel="noopener noreferrer"
      className="reportListItemLink"
    >
      <ListItemButton>
        {icon}
        <ListItemText
          className="reportListItemLinkText"
          primary={reportTitle}
          secondary={reportSubtitle}
        />
      </ListItemButton>
    </Link>
  );
};

function ListItemButton({ children }: { children: any }) {
  const isStorybook = useIsStorybook();

  return isStorybook ? (
    <div style={{ display: "flex" }} className="shiftItem">
      {children}
    </div>
  ) : (
    <ListItem button={true} className="shiftItem">
      {children}
    </ListItem>
  );
}

export default ReportListItem;
